const toggleList = ( evt ) => {
	if ( window.innerWidth >= 768 )
	{
		return;
	}

	const target = evt.target;

	if ( target.closest( 'h3' ) )
	{
		const activeitem = target.closest( 'h3' );

		activeitem.classList.toggle( 'open' );
	}
}

const initList = () => {
	const lists = document.querySelectorAll( 'section.list' );

	if ( !lists.length )
	{
		return;
	}

	lists.forEach( ( component ) => {
		component.addEventListener( 'click', toggleList );
	} );
};

export {
	initList,
};
